import {
    Box,
    ListItem,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, {useMemo} from 'react'

import {colors, styleConfigChakraKeys} from '../../constants'
import {MegaNavRightArrowIcon} from '../icons'
import Link from '../link'
import './MegaLink.scss'

const svgActiveState = {opacity: '1'}

export default function MegaLink({
    isLink,
    item,
    onLinkClick,
    setNextCategoryColumn = false,
    iValue,
    activeLinkId,
    setActiveLinkId
}) {
    const styles = useMultiStyleConfig(styleConfigChakraKeys.megaLink)
    const isActive = useMemo(
        () => activeLinkId === item?.sys?.id,
        [activeLinkId, item?.sys?.id]
    )

    const handleNavLinkHover = () => {
        if (setNextCategoryColumn) setNextCategoryColumn(item?.items || [])
        setActiveLinkId(item?.sys?.id)
    }

    const handleMouseLeave = () => {
        // Optionally, clear the active state when mouse leaves
        setActiveLinkId()
    }

    const onClick = (item) => {
        if (item?.isDisabled) return
        onLinkClick()
        if (item?.url) location.href = item?.url
    }

    return (
        <ListItem
            display={isLink ? 'flex' : 'block'}
            onMouseEnter={handleNavLinkHover}
            onMouseLeave={handleMouseLeave}
        >
            {isLink ? (
                <Link
                    {...styles.linkItem}
                    {..._.omit(item, ['text', 'url'])}
                    url={_.toLower(item.url)}
                    onLinkClick={() => onClick(item)}
                    style={{'--index': iValue, outline: 0}}
                    {...(isActive ? styles.activeState : {})}
                    onClick={() => {
                        onClick(item)
                    }}
                    {...(item.isDisabled ? {pointerEvents: 'none'} : {})}
                    color={item.isDisabled ? colors.grayish : '#000000'}
                >
                    <Text {...styles.linkItemText}>
                        {item?.text || item?.heading}
                    </Text>
                </Link>
            ) : (
                <Box
                    style={{'--index': iValue, outline: 0}}
                    {...styles.linkItem}
                    {...(isActive ? styles.activeState : {})}
                    {...(item.isDisabled ? {pointerEvents: 'none'} : {})}
                >
                    <Text
                        {...styles.linkItemText}
                        cursor="pointer"
                        color={item.isDisabled ? colors.grayish : '#000000'}
                    >
                        {item?.heading || item.text}
                        <MegaNavRightArrowIcon
                            opacity="0"
                            verticalAlign="middle"
                            marginTop="2px"
                            marginLeft="22px"
                            {...(isActive ? svgActiveState : {})}
                        />
                    </Text>
                </Box>
            )}
        </ListItem>
    )
}

MegaLink.propTypes = {
    isLink: PropTypes.bool,
    item: PropTypes.object,
    onLinkClick: PropTypes.func,
    setNextCategoryColumn: PropTypes.func,
    iValue: PropTypes.number,
    activeLinkId: PropTypes.string,
    setActiveLinkId: PropTypes.func
}
